import { sendRequest } from '../../config';

export interface sendResultsParams {
    results: any;
    snr: string;
    email: string;
    nlocaliza: string;
    cpais: string;
}

export interface dataSendResults {
    description?: string;
}

export const sendResults = async (params: sendResultsParams): Promise<dataSendResults> => {
    const ENDPOINT = 'v2/signosvitales/send-results';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
        withCredentials: true,
        skipAuth: true,
    });
};